const setFitsMode = (state, isFitsMode) => {
    state.modal.isFitsMode = isFitsMode
}

const setIsSameDayShippingMode = (state, isSameDayShippingMode) => {
    state.modal.isSameDayShippingMode = isSameDayShippingMode
}

const setMMYMode = (state, isMMYMode) => {
    state.modal.isMMYMode = isMMYMode
}

const setRequiredSelectTypes = (state, data) => {
    // The very first time we set this is what the site has for its default required fitment.
    // We need to store that value once at the beginning so we can power a getter for things that only care about the sites default fitment,
    // not what the category says its default fitment is.
    if (!state.defaultSelectTypes) state.defaultSelectTypes = data
    state.requiredSelectTypes = data
}

const setOptionalSelectTypes = (state, data) => {
    state.optionalSelectTypes = data
}

const initSelects = (state, data) => {
    state.modal.selects = data
}

const setSelectOptions = (state, { index, options }) => {
    const select = state.modal.selects[index]
    select.options = options
    select.isDisabled = false
    select.currentValue = -1
    select.hasError = false

    // if we only have 2 options and the second one is 'n-a' then we want to change the label
    if (options.length === 2 && options[1].value === 'n-a') {
        // Capitalize the Type
        options[1].text = `No ${select.type.charAt(0).toUpperCase() + select.type.slice(1)}`
    } else {
        // We do not want to show n-a when the select has at least 1 valid fitment option
        options.forEach((option) => {
            if (option.value === 'n-a') option.isHidden = true
        })
    }
}

const setSelectError = (state, index) => {
    const select = state.modal.selects[index]
    select.hasError = true
}

const resetSelectErrors = (state) => {
    state.modal.selects.forEach((select) => (select.hasError = false))
}

const setSelectDisabled = (state, index) => {
    const select = state.modal.selects[index]
    select.isDisabled = true
    select.currentValue = -1
    select.hasError = false
}

const setSelectValue = (state, { index, newValue }) => {
    state.modal.selects[index].currentValue = newValue
}

const restoreFitmentData = (state, cookieData) => {
    state.data = cookieData
}

const setFitmentData = function (state, { fitmentData, merge }) {
    if (!fitmentData) return

    // if we get a merge flag, lets take the obj and merge with our existing state (currently only with url YMM)
    const base = !merge ? {} : Object.assign({}, state.data)
    state.data = Object.assign(base, fitmentData)

    if (process.client) {
        this.$clientCookies.set('fitmentData', state.data, {
            secure: process.env.NODE_ENV === 'production',
            expires: 3650, // 10 years
        })
    } else {
        this.$serverCookies.set('fitmentData', JSON.stringify(state.data), {
            httpOnly: false,
            secure: process.env.NODE_ENV === 'production',
            path: '/',
            maxAge: 315360000, // 10 years
        })
    }
}

const clearFitment = function (state) {
    state.data = {}

    if (process.client) {
        this.$clientCookies.remove('fitmentData')
    } else {
        this.$serverCookies.clear('fitmentData', {
            httpOnly: false,
            secure: process.env.NODE_ENV === 'production',
            path: '/',
        })
    }
}

const setIsStoppingInit = (state, isStopping) => {
    state.modal.isStoppingInit = isStopping
}

const setHasRequiredFitmentChanged = (state, bool) => {
    state.hasRequiredFitmentChanged = bool
}

export default {
    setIsStoppingInit,
    setIsSameDayShippingMode,
    setMMYMode,
    setFitsMode,
    setRequiredSelectTypes,
    setOptionalSelectTypes,
    initSelects,
    setSelectOptions,
    setSelectValue,
    setSelectError,
    resetSelectErrors,
    setSelectDisabled,
    restoreFitmentData,
    setFitmentData,
    clearFitment,
    setHasRequiredFitmentChanged,
}
